/* ORAVIE native PDP behaviours.
   Original theme code with no app, CDN or library dependency. Every section
   renders complete, readable HTML first; this file only adds sliding,
   variant switching, accordions, counters and the video lightbox. */
(function () {
  'use strict';

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var behavior = reduce ? 'auto' : 'smooth';

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function once(el, key) { if (el['__opdp_' + key]) return false; el['__opdp_' + key] = true; return true; }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  /* ---------- horizontal scroll-snap sliders ---------- */
  function initSlider(root) {
    if (!once(root, 'slider')) return;
    var track = root.querySelector('[data-opdp-track]');
    if (!track) return;
    var prev = root.querySelector('[data-opdp-prev]');
    var next = root.querySelector('[data-opdp-next]');
    var loop = root.hasAttribute('data-loop');

    function stepSize() {
      var item = track.querySelector('[data-opdp-slide]');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function atStart() { return track.scrollLeft <= 2; }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
    function update() {
      var scrollable = track.scrollWidth > track.clientWidth + 2;
      root.classList.toggle('is-static', !scrollable);
      if (loop) return;
      if (prev) prev.disabled = atStart();
      if (next) next.disabled = atEnd();
    }
    function go(dir) {
      if (loop && dir > 0 && atEnd()) { track.scrollTo({ left: 0, behavior: behavior }); return; }
      if (loop && dir < 0 && atStart()) { track.scrollTo({ left: track.scrollWidth, behavior: behavior }); return; }
      track.scrollBy({ left: dir * stepSize(), behavior: behavior });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    var delay = parseInt(root.getAttribute('data-autoplay'), 10);
    if (delay > 0 && !reduce) {
      var paused = false;
      var pause = function () { paused = true; };
      var resume = function () { paused = false; };
      root.addEventListener('pointerenter', pause);
      root.addEventListener('pointerleave', resume);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', resume);
      track.addEventListener('touchstart', pause, { passive: true });
      setInterval(function () {
        if (!paused && !document.hidden && root.getBoundingClientRect().bottom > 0) go(1);
      }, delay * 1000);
    }
    root.__opdpGo = go;
  }

  /* ---------- product gallery: thumbnails follow the main slider ---------- */
  function initGallery(root) {
    if (!once(root, 'gallery')) return;
    var main = root.querySelector('[data-opdp-main] [data-opdp-track]');
    var thumbs = $$('[data-opdp-thumb]', root);
    if (!main || !thumbs.length) return;

    function index() {
      var slide = main.querySelector('[data-opdp-slide]');
      var w = slide ? slide.getBoundingClientRect().width + (parseFloat(getComputedStyle(main).columnGap) || 0) : main.clientWidth;
      return Math.max(0, Math.min(thumbs.length - 1, Math.round(main.scrollLeft / (w || 1))));
    }
    function mark(i) {
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) {
          var strip = t.closest('[data-opdp-track]');
          if (strip && strip.scrollWidth > strip.clientWidth) {
            strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: behavior });
          }
        }
      });
    }
    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () {
        var slides = $$('[data-opdp-slide]', main);
        if (slides[n]) main.scrollTo({ left: slides[n].offsetLeft - main.offsetLeft, behavior: behavior });
        mark(n);
      });
    });
    var raf = 0;
    main.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(index()); });
    }, { passive: true });
  }

  /* ---------- buy box: variant pills drive the one product form ---------- */
  function initBuybox(root) {
    if (!once(root, 'buybox')) return;
    var dataEl = root.querySelector('[data-opdp-variants]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-opdp-form] input[name="id"]');
    var atc = root.querySelector('[data-opdp-atc]');
    var atcLabel = root.querySelector('[data-opdp-atc-label]');
    var priceEl = root.querySelector('[data-opdp-price]');
    var compareEl = root.querySelector('[data-opdp-compare]');
    var badgeEl = root.querySelector('[data-opdp-badge]');
    var noteEl = root.querySelector('[data-opdp-price-note]');
    var groups = $$('[data-opdp-option]', root);

    function selected() {
      var values = groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var ok = true;
        for (var j = 0; j < values.length; j++) if (v.options[j] !== values[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    function render(v, silent) {
      groups.forEach(function (g) {
        var c = g.querySelector('input:checked');
        var out = g.querySelector('[data-opdp-selected]');
        if (out && c) out.textContent = c.value;
      });
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = data.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (noteEl) noteEl.textContent = v.note || '';
      var onSale = !!v.compare;
      if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !onSale; }
      if (badgeEl) { badgeEl.textContent = v.badge || ''; badgeEl.hidden = !onSale || !v.badge; }
      if (atc) atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? (v.cta || data.atc + (data.showPrice ? ' • ' + v.price : '')) : data.soldOut;
      if (!silent && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      }
      root.dispatchEvent(new CustomEvent('opdp:variant', { bubbles: true, detail: { id: v.id, price: v.price, cta: v.cta || '', note: v.note || '', options: v.options } }));
    }

    groups.forEach(function (g) {
      g.addEventListener('change', function () { render(selected()); });
    });

    /* A browser can restore a different checked card on reload or back/forward.
       Keep the price, button and hidden variant in step with whatever is checked. */
    var initialV = selected();
    if (initialV && idInput && String(initialV.id) !== String(idInput.value)) render(initialV, true);
  }

  /* ---------- short videos: play in view, open full screen on tap ---------- */
  function initVideos(root) {
    if (!once(root, 'videos')) return;
    var dlg = root.querySelector('[data-opdp-modal]');
    var big = dlg ? dlg.querySelector('video') : null;

    /* The muted clips play on their own, like the original slider did; they
       only pause while scrolled out of view to save battery and data. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) play(en.target); else en.target.pause();
        });
      }, { threshold: 0.25 });
      $$('[data-opdp-inline] video', root).forEach(function (v) { io.observe(v); });
    }

    function closeModal() {
      if (!dlg) return;
      if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
    }
    $$('[data-opdp-video-open]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        if (!dlg || !big || !src) return;
        big.src = src;
        big.muted = false;
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        play(big);
      });
    });
    if (dlg) {
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-opdp-modal-close]')) closeModal();
      });
      dlg.addEventListener('close', function () {
        big.pause();
        big.removeAttribute('src');
        big.load();
      });
    }
  }

  /* ---------- <details> rows with an animated height ---------- */
  function initRows(root) {
    if (!once(root, 'rows')) return;
    $$('details[data-opdp-row]', root).forEach(function (d) {
      var summary = d.querySelector('summary');
      var body = d.querySelector('[data-opdp-body]');
      if (!summary || !body || reduce) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var opening = !d.open;
        if (opening) d.open = true;
        var from = opening ? 0 : body.scrollHeight;
        var to = opening ? body.scrollHeight : 0;
        body.style.height = from + 'px';
        body.getBoundingClientRect();
        body.style.height = to + 'px';
        var done = function () {
          body.style.height = '';
          if (!opening) d.open = false;
          body.removeEventListener('transitionend', done);
          clearTimeout(t);
        };
        var t = setTimeout(done, 450);
        body.addEventListener('transitionend', done);
      });
    });
  }

  /* ---------- FAQ: one answer open at a time ---------- */
  function initFaq(root) {
    if (!once(root, 'faq')) return;
    var single = root.hasAttribute('data-single');
    function toggle(item, on) {
      var q = item.querySelector('[data-opdp-faq-q]');
      var a = item.querySelector('[data-opdp-faq-a]');
      item.classList.toggle('is-open', on);
      q.setAttribute('aria-expanded', on ? 'true' : 'false');
      a.style.maxHeight = on ? a.scrollHeight + 'px' : '0px';
    }
    $$('[data-opdp-faq-q]', root).forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('[data-opdp-faq-item]');
        var open = item.classList.contains('is-open');
        if (single) $$('[data-opdp-faq-item].is-open', root).forEach(function (o) { if (o !== item) toggle(o, false); });
        toggle(item, !open);
      });
    });
  }

  /* ---------- numbers count up once when they scroll into view ---------- */
  function initCounters(root) {
    if (!once(root, 'counters') || reduce || !('IntersectionObserver' in window)) return;
    var dur = parseInt(root.getAttribute('data-duration'), 10) || 2000;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-opdp-count'));
      if (!isFinite(to)) return;
      var start = null;
      el.textContent = '0';
      function tick(now) {
        if (start === null) start = now;
        var k = Math.min(1, (now - start) / dur);
        el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))).toLocaleString();
        if (k < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); run(en.target); }
      });
    }, { threshold: 0.4 });
    $$('[data-opdp-count]', root).forEach(function (el) { io.observe(el); });
  }

  function init(scope) {
    document.documentElement.classList.add('opdp-js');
    $$('[data-opdp-slider]', scope).forEach(initSlider);
    $$('[data-opdp-gallery]', scope).forEach(initGallery);
    $$('[data-opdp-buybox]', scope).forEach(initBuybox);
    $$('[data-opdp-videos]', scope).forEach(initVideos);
    $$('[data-opdp-rows]', scope).forEach(initRows);
    $$('[data-opdp-faq]', scope).forEach(initFaq);
    $$('[data-opdp-counters]', scope).forEach(initCounters);
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
